const Wishlist = () => {
  return (
    <div>
      <h1>My Wishlist</h1>
    </div>
  )
}

export default Wishlist